import styled from 'styled-components';
import { Drawer, List, Typography } from 'antd';

const { Title } = Typography;

export const StyledDrawer = styled(Drawer)`
  width: 400px;
`;

export const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

export const StyledList = styled(List)`
  width: 100%;
`;

export const StyledListItem = styled(List.Item)`
  width: 100%;
`;
